





































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Meter } from 'performo-api';

@Component({})
export default class AssetMeterReadings extends Vue {
  @Prop({ required: true }) meters!: Meter[];

  private get meterHeaders() {
    return (index: number) => [
      {
        text: 'Reading (' + this.meters[index].meterUnits + ')',
        align: 'start',
        sortable: false,
        value: 'currentReading'
      },
      {
        text: 'Date',
        sortable: false,
        value: 'date'
      },
      {
        text: 'Work Order #',
        sortable: false,
        value: 'wkordNum'
      },
      {
        text: 'Notes',
        sortable: false,
        value: 'notes'
      }
    ];
  }
}
